export class DashboardCosts {
  firstYear?: number;
  fiveYears?: number;

  constructor(data: any) {
    this.firstYear = data.firstYear;
    this.fiveYears = data.fiveYears;
  }
}
